<template>
	<path d="M7 13L1 7L7 1" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" />
</template>
